export default __webpack_public_path__ + "static/media/product32_slides.e2c88420.webp";